module.exports = __webpack_public_path__ + "static/img/2_9_2.90f0957a.jpg";